import * as React from 'react'
import Vimeo from '@u-wave/react-vimeo';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import {IconButton, styled, Typography } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import { withPrefix } from 'gatsby';
import { useIntl } from 'react-intl';

const LIIndicator = styled('li')({
	display: 'inline'
})

const Indicator = styled(IconButton)({
	display: 'inline'
})

const TypoLegend = styled(Typography)({
	fontSize: '12px',
	color: '#668080',
	textAlign: 'start',
	marginTop: '5px',
})

export default function Media ({medias}) {
  const intl = useIntl()
	const createMedia = (media, i) => {
		if (media?.type === 'video') {
			return (
				<div key={media.id + " " + i}>
					<Vimeo
						video={media?.video_id}
						width="640px"
						height="360px"
						style={{width: '640px', margin: 'auto'}}
						autoplay
					/>
					<TypoLegend>
						{media.media_translations?.find((trans) => (trans.lang === intl.locale))?.legend}
					</TypoLegend>
				</div>
			)
		} else if (media?.type === 'image') {
			return (
				<div key={media.id + " " + i}>
					<img
						src={withPrefix(`/images/media/` + media?.image)}
						alt={"Lorum"}
					/>
					<TypoLegend>
						{media.media_translations?.find((trans) => (trans.lang === intl.locale))?.legend}
					</TypoLegend>
				</div>
			)
		}
	}

	const IndicatorCustom = (handleClick, isSelected, __, label) => {
		return (
			<LIIndicator>
				<Indicator aria-label={label} onClick={handleClick}>
					<CircleIcon sx={{
						fontSize: "12px",
						color: (isSelected) ? '#EE7F38' : '#e8a174',

					}}/>
				</Indicator>
			</LIIndicator>
		)
	}

  return (
    <>
			<Carousel
				showThumbs={false}
				renderIndicator={IndicatorCustom}
			>
				{medias?.map((media, i) => (
					createMedia(media, i)
				))}
			</Carousel>
    </>
  )
}